import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'evsb-number-of-charging-stations',
  templateUrl: './number-of-charging-stations.component.html',
  styleUrls: ['./number-of-charging-stations.component.scss'],
})
export class NumberOfChargingStationsComponent {
  @Input()
  public amount = 0;
  @Output()
  public amountChange = new EventEmitter<number>();
}
